import { Button } from "@mui/material";
import styled from "styled-components";

export const ContainerList = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface IMenuProps {
  expand?: boolean;
  hijos?: boolean;
  modo?: any;
  textMenu?: string;
}

const decideColor = (textColor: string) => {
  if (textColor) return textColor;
  return "black";
};

export const Menu = styled.div<IMenuProps>`
  font-family: MontserratRegular;
  height: 100%;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  background-color: ${(p) => (p.expand ? "#E6E6E6" : "transparent")};
  &:hover {
    background-color: #e6e6e6;
    color: #3c3b39;
    text-decoration: underline;
  }

  ${(p) =>
    p.modo === "oscuro"
      ? `
        color: ${p.expand ? "black" : "white"} ;
        
    `
      : `
        color: ${p.expand ? "#3C3B39" : decideColor(p.textMenu || "")} ;
    `}
`;

export const ContainerSubMenu = styled.div<IMenuProps>`
  background-color: white;
  color: black;
  position: absolute;
  z-index: 9;
  top: 100%;
  transform: translatex(-20px);
  display: ${(p) => {
    return p.expand ? "block" : "none";
  }};
`;
export const SubMenu = styled.div<IMenuProps>`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .btnOnClick {
    color: black;
    padding: 18px;
    width: ${(p) => (p.hijos ? "80%" : "100%")};
    margin: 0;
    text-align: start;

    &:hover {
      background-color: #3c3b39;
      color: white;
      cursor: pointer;
    }
  }

  p {
    color: black;
    padding: 18px;
    width: ${(p) => (p.hijos ? "80%" : "100%")};
    margin: 0;
    text-align: start;
  }

  .btnArrow {
    padding: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20%;

    .icon {
      transition: transform 0.2s;
      &:hover {
        transform: scale(1.3);
      }
    }

    &:hover {
      background-color: #e6e6e6;
      color: black;
    }
  }
`;
export const ItemBox = styled.div<IMenuProps>`
  line-height: 1.5;
  width: 100%;
  text-align: start;

  background-color: ${(p) => (p.expand ? "#E6E6E6" : "transparent")};
  .btnArrow {
    color: ${(p) => (p.expand ? "black" : "")};
  }
  .item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;
export const ContainerVista = styled.div<IMenuProps>`
  background-color: #e6e6e6;
  color: black;
  position: fixed;
  z-index: 1;
  left: 100%;
  top: 0;
  width: 270px;
  display: ${(p) => {
    return p.expand ? "block" : "none";
  }};
  max-height: 100%;
  overflow-y: auto;
`;
